export const PASSWORD_RESET = {
  START: 'PASSWORD_RESET_START',
  SUCCESS: 'PASSWORD_RESET_SUCCESS',
  ERROR: 'PASSWORD_RESET_ERROR',
};